import React from "react";
import  { useState, useEffect } from 'react';
import './classes/CreateAgentMessage.css';
import SalespersonSidebar from './SalespersonSidebar';
import Editor from 'react-simple-wysiwyg';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import { Link,useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";


const CreateAgentMessage = () => {

    const [formData, setFormData] = useState({
        create_agent_message_title:'',
        summary: '',
        body: '',
    });

    const [previewData, setPreviewData] = useState({
        title: '',
        summary: '',
        body: '',
    });

    const [errors, setErrors] = useState({});
    const [showSummary, setShowSummary] = useState(false);
    const [useRichEditor, setUseRichEditor] = useState(true);
    const [PreviewFields, setPreviewFields] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
const navigate = useNavigate();
    // const onEditorChange = (field, value) => {
    //     setFormData(prev => ({ ...prev, [field]: value }));
    // };
    const onEditorChange = (field, e, isRich = true) => {
        let newHtml = e.target.value;

        // Normalize editor output
        const isEmptyHtml = newHtml.trim() === '' || newHtml === '<br>' || newHtml === '<p><br></p>';

        if (isEmptyHtml) {
            newHtml = '';
        } else if (isRich && !newHtml.trim().startsWith('<')) {
        // Wrap plain text in <p> if it's not already HTML
            newHtml = `<p>${newHtml}</p>`;
        }

        setFormData(prev => ({ ...prev, [field]: newHtml }));
    };

       const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000); 

        return () => clearTimeout(timer); 
    }, []);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.create_agent_message_title.trim()) {
            newErrors.create_agent_message_title = "Title field is required.";
        }
        return newErrors;
    };

    const inputStyle = {
        border: errors.create_agent_message_title ? '2px solid red' : '1px solid #777',
    };

    const handlePreviewClick = () => {
        if (formData.create_agent_message_title.trim()) {
            const bodyHtml = formData.body || '';
            const hasBreak = bodyHtml.includes('<!--break-->');
            const breakSummary = hasBreak ? bodyHtml.split('<!--break-->')[0] : null;

            const finalSummary = formData.summary?.trim() || breakSummary || '';

            setPreviewData({
                title: formData.create_agent_message_title,
                summary: finalSummary,
                body: bodyHtml
            });

            setPreviewFields(true);
            setErrors(prev => ({ ...prev, create_agent_message_title: null }));
        } else {
            setErrors(prev => ({
                ...prev,
                create_agent_message_title: "Title field is required."
            }));
            setPreviewFields(false);
        }
    };

    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    var {uid} = useParams();
    var {username} = useParams();
    if(location.state) {
        uid = location.state;
    }
        
        
    const loggedin_uid = localStorage.getItem('uid');

    const app_url = configData.APP_URL;
        
    const domain_url = configData.DOMAIN_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const validationErrors = validateForm();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
             const response = await fetch(app_url+'smwwagency/addagentmessage', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      
             if(data.data.msg == "Success") {
                
                 navigate('/agent-message/'+data.data.id+'/view', { state: { message: data.data.result } });
            } 
       

        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>Create Agent Message</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="create-agent-message-container">
                            {PreviewFields && (
                                <>
                                    <div 
                                        className="messages status" 
                                        style={{ background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,backgroundPosition: '10px 10px' }}
                                    >
                                        The trimmed version of your post shows what your post looks like when promoted to the main page or when exported for syndication.
                                        <span>
                                            You can insert the delimiter "&lt;!--break--&gt;" (without the quotes) to fine-tune where your post gets split.
                                        </span>
                                    </div>

                                    <div className="preview-container">
                                        <div className='preview-trimmed'>
                                            <h4 className="preview-heading">
                                                Preview trimmed version
                                            </h4>
                                            <div className="email-teaser">
                                                <h2 className="email-title">
                                                    <a href="/full-email-page">{previewData.title || ' '}</a>
                                                </h2>
                                                <div className="email-teaser-block1">
                                                    <div className="email-teaser-block2">
                                                        {previewData.summary && (
                                                            <div dangerouslySetInnerHTML={{ __html: previewData.summary }} />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="read-more-link">
                                                    <a href="/full-email-page">Read more</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='preview-full'>
                                            <h4 className="preview-heading">
                                                Preview full version
                                            </h4>

                                            <div className="email-teaser">
                                                <h2 className="email-title">
                                                    Body:
                                                </h2>
                                                <div className="email-teaser-block1">
                                                    <div className="email-teaser-block2">
                                                        <div dangerouslySetInnerHTML={{ __html: previewData.body }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div className="form-item">
                                        {errors.create_agent_message_title && (
                                            <div 
                                                className="form-error" 
                                                style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") no-repeat 2px`}}
                                            >{errors.create_agent_message_title}
                                            </div>
                                        )}
                                        <label htmlFor="create-agent-message-title">
                                            Title  
                                            <span className="form-required" title="This field is required.*">*</span>
                                        </label>
                                        <input 
                                            className="create-agent-message-title-field" 
                                            type="text" 
                                            id="create-agent-message-title" 
                                            name="create_agent_message_title" 
                                            maxLength={100}
                                            value={formData.create_agent_message_title}
                                            onChange={handleChange}
                                            style={inputStyle} 
                                        />
                                    </div>
                                    <div className="createagentmessage-format-wrapper">
                                        <div>
                                            {showSummary && (
                                                <div className="form-item">
                                                    <label htmlFor="create_summary">
                                                        Summary 
                                                        <span>
                                                            (<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>
                                                                Hide Summary
                                                            </a>)
                                                        </span>
                                                    </label>
                                                    <>
                                                        <>
                                                            <Editor 
                                                                containerProps={{ style: { resize: 'vertical' } }} 
                                                                value={formData.summary} 
                                                                onChange={e => onEditorChange('summary', e)}  
                                                            />
                                                        </>
                                                    </>
                                                    <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                </div>
                                            )}
                                    
                                            <div className="form-item">
                                                <label htmlFor="create_body">
                                                    Body 
                                                {!showSummary && (
                                                        <span>
                                                            (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                                Edit Summary
                                                            </a>)
                                                        </span>
                                                    )}
                                                </label>
                                                <>
                                                    {useRichEditor ? (
                                                        <> 
                                                            <Editor 
                                                                containerProps={{ style: { resize: 'vertical' } }} 
                                                                value={formData.body} 
                                                                onChange={e => onEditorChange('body', e, true)}
                                                            />  
                                                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                                Switch to plain text editor
                                                            </a>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <textarea
                                                                id="create_body"
                                                                rows="20"
                                                                value={formData.body} 
                                                                onChange={e => onEditorChange('body', e, false)} 
                                                            />
                                                            <div 
                                                                className="grippie" 
                                                                style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                            >
                                                            </div>
                                                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                                Switch to rich text editor
                                                            </a>
                                                        </>
                                                    )}
                                                </>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-actions">
                                        <input 
                                            type="submit" 
                                            id="create-submit" 
                                            name="" 
                                            value="Save" 
                                            className="form-submit" 
                                        />
                                        <input 
                                            type="button" 
                                            id="edit-preview" 
                                            value="Preview" 
                                            className="form-submit" 
                                            onClick={handlePreviewClick} 
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default CreateAgentMessage;